import styled from "styled-components";

export const Container = styled.div`
	position: absolute;
	bottom: 0;
	right: 0;
	width: 55%;
	height: 30%;
	z-index: 5;

	@media (min-width: 734px) {
		width: 18%;
		height: 42%;
	}
	/* align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	background-repeat: no-repeat;
	background-size: contain;
	background-position-x: center; */
`;

export const CrabImage = styled.img`
	width: 14em;
	position: absolute;
	bottom: 0;
	right: 0;
	object-fit: contain;
`;

export const CrabBubbleContainer = styled.div<{ image?: string }>`
	width: 12em;
	height: 8em;
	position: absolute;
	background-image: url(${(props) => props.image});
	background-repeat: no-repeat;
	background-size: 100% auto;
	z-index: 1;
	top: 7em;
	right: 12em;
	display: flex;
	align-items: center;
	justify-content: center;

	@media (min-width: 734px) {
		width: 70%;
		height: 44%;
	}
`;

export const DescriptionContainer = styled.div`
	position: absolute;
	padding: 0.47em;
	color: #333;
	text-align: center;
	font-weight: 400;
	font-size: 2em;
	font-family: Baloo;
	font-style: normal;
	top: 0.5em;
	left: 0em;

	@media (min-width: 734px) {
		font-size: 1.2em;
		top: 1.7em;
		left: 0.7em;
	}
`;

/** @deprecated */
export const Title = styled.div`
	color: #000;
	line-height: 100%;
	-webkit-text-stroke-width: 2;
	-webkit-text-stroke-color: #fff;
	font-size: clamp(1em, 1.6dvw, 2.16em);

	@media (min-width: 734px) {
		font-size: clamp(1.25em, 1.6dvw, 2.16em);
	}
`;

/** @deprecated */
export const SuperOfferTitle = styled.div`
	color: #000;
	line-height: 100%;
	text-shadow: 0 0 0.25em #fbbd05;
	font-size: clamp(0.94em, 1.6dvw, 1.92em);

	@media (min-width: 734px) {
		font-size: clamp(1.17em, 1.6dvw, 1.92em);
	}
`;

export const Message = styled.div`
	//color: #000;
	line-height: 100%;
	font-size: 0.85em;

	@media (min-width: 734px) {
		font-size: 1.42em;
	}
`;
